import { Component, OnInit } from '@angular/core';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { MenuController, ModalController, Platform } from '@ionic/angular';
import { ApplicationBase } from '@schema/application-base';
import { LayoutService } from '@services/layout/layout.service';
import { SideMenuService } from '@services/menu/side-menu.service';
import { ViewSelectorService } from '@services/view-selector/view-selector.service';

@Component({
  selector: 'app-root',
  templateUrl: './app-root.component.html',
  styleUrls: ['./app-root.component.scss']
})
export class AppRootComponent extends ApplicationBase implements OnInit {
  get showMenu(): boolean {
    return this.layout.hasSideMenu && this.view.inApp;
  }

  constructor(
    private view: ViewSelectorService,
    private layout: LayoutService,
    protected platform: Platform,
    protected modalCtrl: ModalController,
    protected menuService: SideMenuService,
    protected menuController: MenuController,
    protected device: Device
  ) {
    super(platform, modalCtrl, menuService, menuController, device);
  }

  ngOnInit() {}
}
